import React from "react";
import PropTypes from "prop-types";

const InstagramIcon = ({ className, color }) => (
  <svg
    className={className}
    x="0px"
    y="0px"
    viewBox="0 0 35.4 35.4"
    xmlSpace="preserve"
  >
    <g id="ELEMENTS">
      <g>
        <g>
          <path
            d="M27.1,6.3c-1.1,0-2.1,0.9-2.1,2.1c0,1.1,0.9,2.1,2.1,2.1c1.1,0,2.1-0.9,2.1-2.1C29.1,7.2,28.2,6.3,27.1,6.3z"
            fill={color}
          />
          <path
            d="M17.8,9c-4.8,0-8.7,3.9-8.7,8.7c0,4.8,3.9,8.7,8.7,8.7c4.8,0,8.7-3.9,8.7-8.7C26.5,12.9,22.6,9,17.8,9z M17.8,23.3
				c-3.1,0-5.6-2.5-5.6-5.6s2.5-5.6,5.6-5.6c3.1,0,5.6,2.5,5.6,5.6S20.9,23.3,17.8,23.3z"
            fill={color}
          />
          <path
            d="M24.8,35.4H10.6C4.8,35.4,0,30.6,0,24.8V10.6C0,4.8,4.8,0,10.6,0h14.1c5.9,0,10.6,4.8,10.6,10.6v14.1
				C35.4,30.6,30.6,35.4,24.8,35.4z M10.6,3.3c-4,0-7.3,3.3-7.3,7.3v14.1c0,4,3.3,7.3,7.3,7.3h14.1c4,0,7.3-3.3,7.3-7.3V10.6
        c0-4-3.3-7.3-7.3-7.3H10.6z"
            fill={color}
          />
        </g>
      </g>
    </g>
  </svg>
);

InstagramIcon.defaultProps = {
  className: ``,
  color: `white`
};

InstagramIcon.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string
};

export default InstagramIcon;
